import { Component, OnInit, Input } from '@angular/core';
import { AppService } from 'src/app/service/services';
import { CurrentUser } from 'src/app/models/models';

@Component({
  selector: 'app-report-footer',
  templateUrl: './report-footer.component.html',
  styleUrls: ['./report-footer.component.scss']
})
export class ReportFooterComponent implements OnInit {

  @Input() showCurrentUser : boolean = true;
  @Input() showCurrentDateTime : boolean = true;
  @Input() showTotal : boolean = true;

  @Input() isTotalOnDefaultPosition : boolean = true;

  @Input() total : number;

  currentDate : Date = new Date();

  currentUser : CurrentUser;

  constructor(private appService : AppService) { }

  ngOnInit() {

    this.currentUser = this.appService.currentUser;

  }

}
